import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";

interface CodeBlockProps {
  code: string;
  language: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({ code, language }) => {
  return (
    <div
      style={{
        position: "relative",
        border: "1px solid #ddd",
        borderRadius: "5px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          backgroundColor: "#f5f5f5",
          padding: "5px 10px 0px 15px",
          fontSize: "20px",
          fontWeight: "bold",
          // borderBottom: "1px solid #ddd",
          textAlign: "left",
        }}
      >
        {language.toUpperCase()}
      </div>
      <SyntaxHighlighter
        language={language}
        style={tomorrow}
        customStyle={{ padding: "0px" }}
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeBlock;
